import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';

import { ApWindowService } from '@ap/cdk';
import { MijnNavigatieRoute, MijnNavigatieService, MijnRouteKey, MijnRoutes } from '@ap/mijn-navigatie';

@Injectable({ providedIn: 'root' })
export class MijnTemplateNavigation {
    public constructor(
        private readonly apWindowService: ApWindowService,
        private readonly mijnNavigatieService: MijnNavigatieService,
        private readonly windowService: ApWindowService,
        private readonly router: Router
    ) {}

    public external(href: string): void {
        this.windowService.location_href(href);
    }

    public internal(href: string): void {
        this.router.navigateByUrl(href);
    }

    public toContact(): void {
        this.mijnNavigatieService.navigate(MijnRouteKey.CONTACT);
    }

    public isMijnUrl(): boolean {
        return this.mijnNavigatieService.isMijnUrl(this.getCurrentUrl());
    }

    public hasDynamicRoute(): boolean {
        const history = this.mijnNavigatieService.getHistory();
        return history?.routes.length > 0;
    }

    public dynamicBack(useRouteKey = true): void {
        const previousNavigatieRoute = this.getSecondToLastRoute();
        const previousRouteKey = MijnNavigatieService.getRouteKeyForUrl(previousNavigatieRoute.url);
        if (useRouteKey) {
            if (previousRouteKey && !this.isDynamicParameterizedPath(previousRouteKey)) {
                this.mijnNavigatieService.navigate(previousRouteKey, this.getParamsFromUrl(previousNavigatieRoute.url));
            } else {
                this.mijnNavigatieService.navigateByUrl(previousNavigatieRoute.url);
            }
        } else {
            this.external(previousNavigatieRoute.url);
        }
    }

    public getCurrentUrl(): string {
        return this.apWindowService.location_href() as string;
    }

    private getSecondToLastRoute(): MijnNavigatieRoute {
        const history = this.mijnNavigatieService.getHistory();
        const stepsBack = history.routes.length === 1 ? 1 : 2;
        return history.routes[history.routes.length - stepsBack];
    }

    private getParamsFromUrl(url: string): Params {
        const urlParams = new URLSearchParams(url.split('?')[1]);
        return Object.fromEntries(urlParams);
    }

    private isDynamicParameterizedPath(routeKey: MijnRouteKey): boolean {
        const { path } = MijnRoutes.get(routeKey);
        return path ? path.includes(':') : false;
    }
}
